
import { ELECTRICAL_ASPECT_METADATA } from '../../aspects/model/electrical-aspect.metadata';
import { MAINTENANCE_ASPECT_METADATA } from '../../aspects/model/maintenance-aspect.metadata';
import { MECHANICAL_ASPECT_METADATA } from '../../aspects/model/mechanical-aspect.metadata';
import { ASSET_TYPE_METADATA } from '../../assettype/model/asset-type.metadata';
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { COST_CENTRE_METADATA } from '../../costcentre/model/cost-centre.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class AssetMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('Asset', {
      assetId: <PropertyMetadata> {
        name: 'assetId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      assetType: <PropertyMetadata> {
        name: 'assetType',
        type: 'AssetType',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ASSET_TYPE_METADATA;
        },
        byReference: true,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      costCentre: <PropertyMetadata> {
        name: 'costCentre',
        type: 'CostCentre',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return COST_CENTRE_METADATA;
        },
        byReference: true,
        unique: false
      },
      electricalAspect: <PropertyMetadata> {
        name: 'electricalAspect',
        type: 'ElectricalAspect',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.OneToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ELECTRICAL_ASPECT_METADATA;
        },
        byReference: false,
        unique: false
      },
      maintenanceAspect: <PropertyMetadata> {
        name: 'maintenanceAspect',
        type: 'MaintenanceAspect',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.OneToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return MAINTENANCE_ASPECT_METADATA;
        },
        byReference: false,
        unique: false
      },
      mechanicalAspect: <PropertyMetadata> {
        name: 'mechanicalAspect',
        type: 'MechanicalAspect',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.OneToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return MECHANICAL_ASPECT_METADATA;
        },
        byReference: false,
        unique: false
      },
      comments: <PropertyMetadata> {
        name: 'comments',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      composedAssetClass: <PropertyMetadata> {
        name: 'composedAssetClass',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      description: <PropertyMetadata> {
        name: 'description',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 2000,
        unique: false
      },
      identityReference: <PropertyMetadata> {
        name: 'identityReference',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      importDataMap: <PropertyMetadata> {
        name: 'importDataMap',
        type: '{ [id: string]: any; }',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      latestRoutineMaintenanceDate: <PropertyMetadata> {
        name: 'latestRoutineMaintenanceDate',
        type: 'Date',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      location: <PropertyMetadata> {
        name: 'location',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      manufacturer: <PropertyMetadata> {
        name: 'manufacturer',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      model: <PropertyMetadata> {
        name: 'model',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      nextRoutineMaintenanceRequiredDate: <PropertyMetadata> {
        name: 'nextRoutineMaintenanceRequiredDate',
        type: 'Date',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      nextRoutineMaintenanceWarningDate: <PropertyMetadata> {
        name: 'nextRoutineMaintenanceWarningDate',
        type: 'Date',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      purchaseDate: <PropertyMetadata> {
        name: 'purchaseDate',
        type: 'Date',
        temporalType: TemporalType.DATE,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      purchasePrice: <PropertyMetadata> {
        name: 'purchasePrice',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      status: <PropertyMetadata> {
        name: 'status',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      tags: <PropertyMetadata> {
        name: 'tags',
        type: 'string',
        plural: true,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 512,
        unique: false
      },
      updatedBy: <PropertyMetadata> {
        name: 'updatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedDate: <PropertyMetadata> {
        name: 'updatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.assetId;
    return nullIfContainsNull(result);
  }
}



